import React, { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AccessibilityHiddenImg } from '@skillz/accessibility';
import { getClassByNum } from "../../../../../shared/utils/utils";
import { logout } from "../../../../../shared/store/redux/auth-actions";
import TranslateBtns from "../../../../../shared/components/ui/translateBtns/TranslateBtns";
import Text from "../../../../../shared/components/features/text/Text";
import Icon from "../../../../../shared/components/ui/icons/Icon";
import userProfile from "../../../../../assests/userProfile.png"
import googleExplainIcon from "../../../../../assests/googleExplainIcon.png"
import iconsList from "../../../../../shared/components/ui/icons/iconsList";
import ChangeSchool from "../../../../../teacher/layout/changeSchool/ChangeSchool";
import classes from './UserDetails.module.css'

const UserDetails = ({ close }) => {

    const dispatch = useDispatch();
    const [copiedEmail, setCopiedEmail] = useState("");
    const { name, studentkita } = useSelector(state => state.auth.user);
    const generalData = useSelector((state) => state.uiData.general);
    const { texts } = useSelector(state => state.translate);
    const { user, isStudent, userDetails } = useSelector(state => state.auth);
    const schools = useMemo(() => userDetails?.schools, [userDetails]);
    const [domainNames, setDomainNames] = useState();

    useEffect(() => {
        if (!userDetails?.defaultSchool)
            return;

        setDomainNames([
            ...userDetails.defaultSchool.gcrDomainName ? [{ domainName: userDetails.defaultSchool.gcrDomainName, title: texts.organizationEmail, icon: iconsList.google}] : [],
            ...userDetails.defaultSchool.microsoftDomainName ? [{ domainName: userDetails.defaultSchool.microsoftDomainName, title: texts.microsoftEmail, icon: iconsList.microsoft }] : [],
        ]);
    }, [userDetails?.defaultSchool]);

    // const moveToMatriculation = () => {
    //     navigate(`/${pathRouts.BGT}`, { state: { openPopup: true } });
    // }

    const handleCopyLink = (email) => {
        navigator.clipboard.writeText(email)
        setCopiedEmail(email);
        setTimeout(() => setCopiedEmail(""), 300);
    }

    return (
        <div className={classes.UserDetails}>
            <Icon className={classes.Close} size="36px" name={iconsList.close} onClick={() => close && close()} />
            <div className={classes.UserProfile}>
                <AccessibilityHiddenImg src={userProfile} />
            </div>

            <p className={classes.UserName}>{name}</p>

            <div className={classes.Line}></div>

            <div className={classes.DetailsWrapper}>
                <div className={classes.DetailsUser}>
                    <div className={classes.Details}>
                        <label>{texts.city}</label>
                        <p>{userDetails?.defaultSchool?.city}</p>
                    </div>
                    {isStudent ?
                        <>
                            <div className={classes.Details}>
                                <label>{texts.school}</label>
                                <p>{userDetails?.defaultSchool?.name}</p>
                            </div>
                            <div className={classes.Details}>
                                <label>{texts.class}</label>
                                <p>{getClassByNum(studentkita)}</p>
                            </div>
                        </>
                        :
                        <>
                            {schools?.length > 1 &&
                                <div className={classes.Details}>
                                    <div>{texts.school}</div>
                                    <ChangeSchool />
                                </div>
                            }
                        </>
                    }
                </div>

                {domainNames && <>
                    {domainNames?.map(domainName => {
                        const email = `${user?.exidentifier}@${domainName.domainName}`;
                        return <>
                            <div className={classes.LineMail}></div>
                            <div className={classes.OrganizationEmail}>
                                <p className={classes.OrganizationEmailText}>{domainName.title}</p>
                                <div className={classes.copyIconWrapper}>
                                    <Icon name={iconsList.copy} size="24px" color="#8F8F8F" className={classes.CopyIcon} onClick={() => handleCopyLink(email)}/>
                                    <div className={classes.MailWrapper}>
                                        <p className={`${classes.Mail} ${copiedEmail === email ? classes.Copied : ""}`}>{email}</p>
                                        <Icon name={domainName.icon} size="17px" className={classes.GmailIcon} />
                                    </div>
                                </div>
                            </div>
                        </>;
                    })}
                    <div className={classes.LineMail}></div>
                </>}

                {generalData?.googleExplainLink && <div className={classes.GoogleExplain} onClick={() => window.open(generalData?.googleExplainLink, "_blank", "noopener,noreferrer")}>
                    <img src={googleExplainIcon} alt="googleExplainicon" />
                    <p>{texts.GoogleExplainText}</p>
                </div>}
            </div>
            {/* {hasMatriculationRouteFunc(isAuth, user, isStudent, generalData) && <>
            <div className={classes.Line}></div>
            <AccessibilityClickableDiv className={classes.MatriculationSetting} onClick={moveToMatriculation}>
                <AccessibilityHiddenImg src={settingIcon} />
                <p className={classes.SettingText}>{texts.editMatriculationSetting}</p>
            </AccessibilityClickableDiv>
            </>} */}
            <TranslateBtns />
            <button className={classes.Logout} onClick={() => dispatch(logout(user?.exidentifier))}><Text>{texts.logout}</Text></button>
        </div >
    )
}

export default UserDetails;